module.exports = __webpack_public_path__ + "static/media/house_on.ab7a6b7b.png";